$(document).ready(function () {
    var loadOnClick = $('.execute-on-click').val();
    
    if (!loadOnClick) {
        carregarSellerReview();
    }

    $(document).on('click', '.validate-review-btn', function () {
        carregarSellerReview($(this).data('seller-id'), $(this).data('order-number'));
    });

    function carregarSellerReview(sellerId, orderNumber) {
        var url = $('.review-seller-url').val();

        if (url) {
            if ($('#sellerReviewModal').find('.invalid-feedback').hasClass('d-block')) {
                $('#sellerReviewModal').find('.invalid-feedback').text('');
                $('#sellerReviewModal').find('.invalid-feedback').removeClass('d-block').addClass('d-none');
            }

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                data: {
                    sellerId: sellerId || '',
                    orderNumber: orderNumber || ''
                },
                success: function (response) {
                    $('#sellerReviewModal').remove();
                    $('body').append(response);
                    $('#sellerReviewModal').modal('show');

                    var orderNumber = $('.relevant-data').data('order-number');
                    var sellerId = $('.relevant-data').data('seller-id');

                    if (orderNumber && sellerId) {
                        $('#alreadyReviewedToast').modal('show');
                        setTimeout(() => {
                            $('#alreadyReviewedToast').modal('hide');
                        }, 2000);
                    }

                    initializeStarRating();
                },
                error: function (xhr, status, error) {
                    console.error("Erro na requisição AJAX:", xhr.responseText);
                }
            });
        }
    }

    function initializeStarRating() {
        $(document).off("click", ".rating-stars .star").on("click", ".rating-stars .star", function () {
            var sellerId = $(this).closest(".rating-stars").data("seller-id");
            var rating = $(this).data("value");

            $(this).parent().find(".star").each(function () {
                $(this).toggleClass("icon-star-full", $(this).data("value") <= rating);
                $(this).toggleClass("icon-star", $(this).data("value") > rating);
            });

            var commentBox = $('.review-comment-' + sellerId);

            if (rating > 0 && commentBox.hasClass('d-none')) {
                commentBox.removeClass('d-none');
            }

            checkAllRatingsCompleted();

            if ($('#sellerReviewModal').find('.invalid-feedback').hasClass('d-block')) {
                $('#sellerReviewModal').find('.invalid-feedback').text('');
                $('#sellerReviewModal').find('.invalid-feedback').removeClass('d-block').addClass('d-none');
            }
        });

        $(document).off("click", ".review-comment textarea").on("click", ".review-comment textarea", function () {
            if ($('#sellerReviewModal').find('.invalid-feedback').hasClass('d-block')) {
                $('#sellerReviewModal').find('.invalid-feedback').text('');
                $('#sellerReviewModal').find('.invalid-feedback').removeClass('d-block').addClass('d-none');
            }
        });

        $(document).off("click", "#submitReview").on("click", "#submitReview", function () {
            var reviews = [];

            $(".seller-review-modal").each(function () {
                var sellerId = $(this).data('seller-id');
                var orderId = $(this).data('order-id');
                var rating = $(this).find('.icon-star-full').length;

                if (rating > 0) {
                    var comment = $("#reviewComment-" + sellerId).val() || "";

                    reviews.push({
                        sellerId: sellerId,
                        rating: rating,
                        comment: comment,
                        orderId: orderId
                    });
                }
            });

            var sendUrl = $('.review-seller-url-submit').val();

            if (sendUrl) {
                $.ajax({
                    url: sendUrl,
                    type: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(reviews),
                    success: function (response) {
                        $('#sellerReviewModal').modal('hide');
                        $('#successToast').toggleClass('d-none').modal('show');
                        
                        setTimeout(() => {
                            $('#successToast').modal('hide');
                        }, 1800);
                    },
                    error: function (e) {
                        $('#sellerReviewModal').find('.invalid-feedback').text('Erro ao enviar avaliação');
                        $('#sellerReviewModal').find('.invalid-feedback').toggleClass('d-none d-block');
                    }
                });
            }
        });
    }

    function checkAllRatingsCompleted() {
        var allRated = true;

        $(".rating-stars").each(function () {
            if ($(this).find(".icon-star-full").length === 0) {
                allRated = false;
                return false;
            }
        });

        $("#submitReview").prop("disabled", !allRated);
    }
});